import { render, staticRenderFns } from "./UploadIncomeConfirmation.vue?vue&type=template&id=9bb66400"
import script from "./UploadIncomeConfirmation.vue?vue&type=script&lang=js"
export * from "./UploadIncomeConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports